module.exports = __webpack_public_path__ + "h5/img/live-logo.17b0066d.jpg";